import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { LineaVenta } from "../models/LineaVentaModel";
import { Producto } from "../models/ProductoModel";

const productoId = (producto: Producto) => Number((producto as any).IDPRODUCTO ?? (producto as any).idProducto ?? (producto as any).IdProducto ?? 0);

type Props = { productos: Producto[]; revision: number; lineas: LineaVenta[]; setLineas: Dispatch<SetStateAction<LineaVenta[]>> };

export const CatalogoVentaActualizadoDialog = ({ productos, revision, lineas, setLineas }: Props) => {
  const previousRevision = useRef(revision);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (revision !== previousRevision.current) {
      previousRevision.current = revision;
      if (lineas.length > 0) setOpen(true);
    }
  }, [lineas.length, revision]);

  const actualizar = () => {
    const actuales = new Map(productos.map((producto) => [productoId(producto), producto]));
    setLineas((actualesLineas) => actualesLineas.map((linea) => {
      const actualizado = actuales.get(productoId(linea.producto));
      return actualizado ? { ...linea, producto: { ...actualizado } } : undefined;
    }).filter((linea): linea is LineaVenta => Boolean(linea)));
    setOpen(false);
  };

  return <Dialog open={open} onClose={() => setOpen(false)}>
    <DialogTitle>Productos para venta actualizados</DialogTitle>
    <DialogContent><DialogContentText>Cambiaron precios o productos habilitados para vender. Puede actualizar las líneas cargadas o conservar sus precios actuales.</DialogContentText></DialogContent>
    <DialogActions><Button onClick={() => setOpen(false)}>Conservar precios</Button><Button variant="contained" onClick={actualizar}>Actualizar líneas</Button></DialogActions>
  </Dialog>;
};
